module.exports = __webpack_public_path__ + "static/media/logo-google-ads.7fb01c65.svg";